import PropTypes from "prop-types";
import React from "react";
import OfferCheckboxCardItem from "./OfferCheckboxCardItem";

const OfferCheckboxCards = ({ items, onCheckBoxClick }) =>
	items.map((applicableOfferData) => (
		<OfferCheckboxCardItem
			key={applicableOfferData.id}
			applicableOfferData={applicableOfferData}
			onCheckBoxClick={onCheckBoxClick}
		/>
	));

OfferCheckboxCards.propTypes = {
	items: PropTypes.array.isRequired,
	onCheckBoxClick: PropTypes.func.isRequired,
};

export default React.memo(OfferCheckboxCards);
